import { createIcon, Svg } from "@gluestack-ui/icon";
import { Path, Mask, Rect, G } from "react-native-svg";

const InjectionIcon = createIcon({
  Root: Svg,
  viewBox: "0 0 36 36",
  path: (
    <>
      <Mask
        id="mask0_1035_9232"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="36"
        height="36"
      >
        <Rect width="36" height="36" stroke="none" />
      </Mask>
      <G mask="url(#mask0_1035_9232)">
        <Path
          d="M19.8144 33.0156L16.8144 30.7656V24.7656H15.3144C14.4894 24.7656 13.7831 24.4719 13.1956 23.8844C12.6081 23.2969 12.3144 22.5906 12.3144 21.7656V10.5156C11.8894 10.5156 11.5331 10.3719 11.2456 10.0844C10.9581 9.79687 10.8144 9.44062 10.8144 9.01562C10.8144 8.59062 10.9581 8.23437 11.2456 7.94687C11.5331 7.65937 11.8894 7.51562 12.3144 7.51562H16.8144V5.26562H16.0644C15.6394 5.26562 15.2831 5.12187 14.9956 4.83437C14.7081 4.54687 14.5644 4.19062 14.5644 3.76562C14.5644 3.34062 14.7081 2.98437 14.9956 2.69687C15.2831 2.40937 15.6394 2.26562 16.0644 2.26562H20.5644C20.9894 2.26562 21.3456 2.40937 21.6331 2.69687C21.9206 2.98437 22.0644 3.34062 22.0644 3.76562C22.0644 4.19062 21.9206 4.54687 21.6331 4.83437C21.3456 5.12187 20.9894 5.26562 20.5644 5.26562H19.8144V7.51562H24.3144C24.7394 7.51562 25.0956 7.65937 25.3831 7.94687C25.6706 8.23437 25.8144 8.59062 25.8144 9.01562C25.8144 9.44062 25.6706 9.79687 25.3831 10.0844C25.0956 10.3719 24.7394 10.5156 24.3144 10.5156V21.7656C24.3144 22.5906 24.0206 23.2969 23.4331 23.8844C22.8456 24.4719 22.1394 24.7656 21.3144 24.7656H19.8144V33.0156ZM15.3144 21.7656H21.3144V19.5156H18.6894C18.3894 19.5156 18.1269 19.4031 17.9019 19.1781C17.6769 18.9531 17.5644 18.6906 17.5644 18.3906C17.5644 18.0906 17.6769 17.8281 17.9019 17.6031C18.1269 17.3781 18.3894 17.2656 18.6894 17.2656H21.3144V15.0156H18.6894C18.3894 15.0156 18.1269 14.9031 17.9019 14.6781C17.6769 14.4531 17.5644 14.1906 17.5644 13.8906C17.5644 13.5906 17.6769 13.3281 17.9019 13.1031C18.1269 12.8781 18.3894 12.7656 18.6894 12.7656H21.3144V10.5156H15.3144V21.7656Z"
          stroke="none"
        />
      </G>
    </>
  ),
});

InjectionIcon.displayName = "InjectionIcon";
export { InjectionIcon };
